import { authedFetch } from '@features/auth/api/authRefresh'
import type { UserPreferences } from '../types'

/**
 * Preferences REST client (Track D)。
 *
 * GET / PUT `/api/users/me/preferences` を `authedFetch` 経由で叩く (401 retry あり)。
 */

const BASE = '/users/me/preferences'

export interface PreferencesEnvelope {
  preferences: UserPreferences
}

export const getPreferences = (): Promise<PreferencesEnvelope> =>
  authedFetch<PreferencesEnvelope>(BASE)

export const updatePreferences = (partial: UserPreferences): Promise<PreferencesEnvelope> =>
  authedFetch<PreferencesEnvelope>(BASE, {
    method: 'PUT',
    body: partial,
  })
